import React, { useCallback } from "react";
import { observer } from "mobx-react";
import { errorExplanationOptions, triggerAnalystCommentModal, getCommentIconRenderingInfo, getInputRenderingInfo } from '../helpers'
import store from './Stores/SurveyStore'
import userStore from './Stores/UserStore'
import { saveValueNew, openPrevYearPanel } from "../control";
import { InputState } from "../Enums/constants";
import { Tooltip } from 'react-tippy';
import { getSurveyResponseValue, setSurveyResponseValue } from "../Helpers/General/SurveyResponsesHelper";
const classNames = require('classnames');

const getInputStateId = (value) => {
    const normalizedValue = (value ?? "").toUpperCase()
    if (store.local.naList.includes(normalizedValue)) {
        return InputState.NA
    }
    if (store.local.unknownList.includes(normalizedValue)) {
        return InputState.UNKNOWN
    }
    return InputState.NOT_SET
}

const SurveyRadioButton = observer((props) => {
    const storeValue = getSurveyResponseValue(props.name, props.rowData)
    const commentRenderingInfo = getCommentIconRenderingInfo(props.name)
    const inputRenderingInfo = getInputRenderingInfo(props.name, props.inputType)

    const onChange = useCallback((e) => {
        const value = e.target.value;
        setSurveyResponseValue(props.name, value, props) // Save to mobx store
        saveValueNew(props.name, value, { inputStateId: getInputStateId(value) }) // Save to database
    }, [props.name, props]);
    
    const renderRadioButton = (option, index) => {
        const divKey = `${props.name}-${option}-radio-div`
        const divClassNames = classNames("radioBtn", inputRenderingInfo.inputColor, {
            "firstRadioOption": index === 0,
            "otherRadioOption": index > 0
        })

        const radioButtonId = `${props.name}-${option}-radio`;
        const radioButtonName = `${props.name}`;
        return (
            <div key={divKey} className={divClassNames} onClick={() => openPrevYearPanel(props.name)}>
                <input
                    type='radio'
                    id={radioButtonId}
                    name={radioButtonName}
                    value={option}
                    onChange={onChange}
                    checked={option.toLowerCase() === storeValue.toLowerCase()}
                    disabled={inputRenderingInfo.isDisabled}/>
                <label htmlFor={radioButtonId}>{option}</label>
            </div>
        )
    }
    
    const renderRadioButtons = () => {
        if (store.questionMode) {
            return <input
                disabled={true}
                className={`${inputRenderingInfo.textClassName} numInput`}
                type="text"
                name={props.name}
                value={props.name}/>
        }
        
        const validOptions = props.options.filter((el) => el !== "")
        const radioButtons = validOptions.map(renderRadioButton);
        return <div className="radioButtonDiv" role="radiogroup">{radioButtons}</div>
    }

    const renderRadioButtonsWithTooltip = () => {
        return <Tooltip
            disabled={store.questionMode}
            position="top"
            trigger="mouseenter"
            animation="fade"
            delay={250}
            hideOnClick="false"
            arrow="true"
            size="small"
            interactive="true"
            html={(
                <div className="genericTooltip">
                    {inputRenderingInfo.feedbackComment}<br />
                    {errorExplanationOptions(props.name, inputRenderingInfo, storeValue)}
                </div>
            )}
            popperOptions={{
                modifiers: {
                    preventOverflow: {
                        enabled: false,
                    },
                    flip: {
                        enabled: false,
                    },
                },
            }}
        >
            {renderRadioButtons()}
        </Tooltip>
    }
    
    const renderAnalystModeIcon = () => {
        return (
            <a title={commentRenderingInfo.hoverComment} style={{marginBottom: '8px'}}>
                <i
                    className={`fa fa-comment ${commentRenderingInfo.className}`}
                    onClick={() => triggerAnalystCommentModal(props.name)}>
                </i>
            </a>
        )
    } 
    
    const hasFeedbackComment = !!inputRenderingInfo.feedbackComment
    const shouldShowAnalystModeIcon = store.analystMode && userStore.accountInfo?.isAnalyst === true
    return (
        <React.Fragment>
            {hasFeedbackComment ? renderRadioButtonsWithTooltip() : renderRadioButtons()}
            {shouldShowAnalystModeIcon && renderAnalystModeIcon()}
        </React.Fragment>
    );
});
export default SurveyRadioButton;
